import React from 'react';

let styleObj = {
    table:{
        border:"0.08rem solid #eee",
        borderRadius:"0.5rem",
        padding:"0 1.5rem"
    },
    tableBox: {
        width: "100%",
        height:"100%",
        position: "relative"
    },
    tableCont: { 
        // overflowY: "hidden",
        // overflowX: "scroll"
    },
    lockingBox: {
        background: "#fff",
        position: "absolute",
        zIndex:"10"
    },
    thead: {
        display: "block",
        width: "100%"
    },
    lockTheadTr: {
        height: "3.125rem",
        textAlign: "center",
        color: "#888",
        borderBottom: "#eee solid 0.08rem",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRight: "#eee solid 0.08rem"
    },
    theadTr: {
        height: "3.125rem",
        textAlign: "center",
        color: "#888",
        borderBottom: "#eee solid 0.08rem",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    locktbody:{
        // background:"red",
        display: "block",
        width: "100%",
        borderRight: "0.1rem solid #9f9f9f"
    },
    tbody: {
        display: "block",
        width: "100%"
    },
    tbodyTr1: {
        height: "2.25rem",
        textAlign: "center",
        color: "#000",
        // borderBottom: "#eee solid 0.08rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background:"#fff"
    },
    tbodyTr2: {
        height: "2.25rem",
        textAlign: "center",
        color: "#000",
        // borderBottom: "#eee solid 0.08rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background:"#f1f8ff"
    },
    emptyBox: {
        height: "15rem"
    },
    loadBox: {
        textAlign: "center",
        display: "block",
        position: "absolute",
        width: "100%",
        height: "15rem",
    },
    loading: {
        position: "relative",
        height: "100%"
    },
    emptyText: {
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }
};

export {
    styleObj
};
